export default {
  tip: {
    fromSuccess: 'ສົ່ງສຳເລັດແລ້ວ',
  },
  login: {
    linkList: [
      { name: 'Star Credits Mall', url: '/' },
      {
        name: 'ລົງທະບຽນເປັນເທຣດເດີ',
        url: 'https://tw.fisg.com/register/trader?link_id=ct01egz0&referrer_id=v4w8jplv',
      },
    ],
    registered: {
      text: 'ບໍ່ມີບັນຊີບໍ? ກົດລົງທະບຽນ >>',
      url: 'https://tw.fisg.com/register/trader?link_id=ct01egz0&referrer_id=v4w8jplv',
    },
    shouye: {
      url: '/',
    },
    forgot: 'ລືມລະຫັດຜ່ານ?',
    title: 'ການ​ເຂົ້າ​ສູ່​ລະ​ບົບ​ບັນ​ຊີ​',
    email: 'ກ່ອງຈົດໝາຍ',
    pwd: 'ລະຫັດຜ່ານ',
    denglu: 'ເຂົ້າສູ່ລະບົບ',
    mima: 'ລືມລະຫັດຜ່ານ',
    Reset: 'ຣີເຊັດລະຫັດຜ່ານ',
    p_email: 'ກະລຸນາໃສ່ອີເມວ',
    p_pwd: 'ກະລຸນາໃສ່ລະຫັດຜ່ານ',
    p_new_pwd: 'ກະລຸນາໃສ່ລະຫັດຜ່ານຂອງທ່ານ',
    z_email: 'ກະລຸນາໃສ່ທີ່ຢູ່ອີເມວທີ່ຖືກຕ້ອງ',
    long: 'ຄວາມຍາວ 6 ຫາ 18 ຕົວອັກສອນ',
    determine: 'ກໍານົດ',
    Valid:
      'ສົ່ງຄໍາຮ້ອງຂໍການປ່ຽນລະຫັດຜ່ານສຳເລັດເເລ້ວ ກະລຸນາກວດເບິ່ງອີເມວຂອງທ່ານ ແລະກວດເບິ່ງລິ້ງຣີເຊັດ ລິ້ງສາມາດນຳໃຊ້ໄດ້ຢ່າງຖືກຕ້ອງພາຍໃນ 24 ຊົ່ວໂມງ!',
    Help_reset: 'ໃສ່ອີເມວລົງທະບຽນແລ້ວພວກເຮົາຈະຊ່ວຍປ່ຽນລະຫັດຜ່ານຂອງທ່ານ',
  },
  myhead: {
    loginName: 'ເຂົ້າສູ່ລະບົບ',
    Personalcenter: 'ສູນສ່ວນຕົວ',
    placeholder: NaN,
    myhead_a: 'ໜ້າຫຼັກ',
    myhead_b: 'ການຊື້ຂາຍ',
    myhead_bc: 'ເເພລດຟອມການຊື້ຂາຍ',
    myhead_c: 'ເເພລດຟອມ',
    myhead_d: 'ໂຮງຮຽນເທຣດ',
    myhead_e: 'ບໍລິສັດ',
    myhead_f: 'ໃຫ້ Interstellarfx ຊ່ວຍເຫຼືອທ່ານ',
    myhead_g: 'ເປັນນັກເທຣດທີ່ດີທີ່ສຸດ',
    myhead_h: 'ເລີ່ມການຊື້ຂາຍ',
    myhead_i: 'ລອງເທຣດບັນຊີເດໂມ່',
    myhead_j: {
      text: 'ເເຄມເປນອອນໄລ໌',
      url: 'https://www.interstellarfx.net/zh/trade-cashback',
    },
    myhead_k: 'ເງິນຄືນຈາກທຸລະກຳ',
    myhead_l: 'ຜະລິດຕະພັນການຊື້ຂາຍ',
    myhead_m: 'ການຊື້ຂາຍທີ່ກ່ຽວຂ້ອງ',
    myhead_n: 'ໂຮງຮຽນແລກປ່ຽນຕ່າງປະເທດ',
    myhead_o: 'ເເຄມເປນສະສົມຄະເເນນ Mid-Autumn Festival',
    myhead_p: 'ປະກາດ InterStellar',
    myhead_q: 'ການຄາດການຕະຫຼາດ',
    myhead_r:
      'ໃນຖານະເປັນຜະລິດຕະພັນທາງດ້ານການເງິນທີ່ຊັບຊ້ອນ, ສັນຍາສໍາລັບຄວາມແຕກຕ່າງ (CFDs) ມີຄວາມສ່ຽງສູງທີ່ຈະສູນເສຍຢ່າງໄວວາເນື່ອງຈາກລັກສະນະທີ່ມີ leveraged. ບັນຊີນັກລົງທຶນຂາຍຍ່ອຍສ່ວນໃຫຍ່ບັນທຶກການສູນເສຍທຶນຂອງພວກເຂົາໄວ້ໃນສັນຍາສ່ວນຕ່າງ CFDs. ທ່ານຄວນພິຈາລະນາວ່າທ່ານເຂົ້າໃຈຢ່າງຄົບຖ້ວນກ່ຽວກັບກົດລະບຽບຂອງ CFDs ແລະລວມທັງຄວາມສ່ຽງສູງທີ່ທ່ານອາດຈະສູນເສຍເງິນທຶນຂອງທ່ານ.',
    myhead_s: 'ບໍລິສັດ',
    myhead_t: 'ຕະຫຼາດ',
    myhead_u: 'ບັນຊີ',
    myhead_v: 'ການວິເຄາະແລະການສຶກສາ',
    myhead_v_a: 'ການວິເຄາະ',
    myhead_v_b: 'ການສຶກສາ',
    myhead_w: 'ການຊີ້ນໍາ',
    myhead_x: 'ປະກັນໄພ',
    myhead_y: 'ການປະຕິບັດຕາມກົດໝາຍ',
    myhead_z: 'ຂ່າວຫຼ້າສຸດ',
    myhead_aa: 'ຄູ່ມືການຊື້ຂາຍ',
    myhead_bb: 'ຄຳສັບການຊື້ຂາຍ',
    myhead_cc: 'ຂ່າວດ່ວນ',
    myhead_dd: 'ການວິເຄາະທຸລະກໍາ',
    myhead_ee: 'ການລົງທຶນ Forex',
    myhead_ff: 'ການເປັນສະປອນເຊີ & ຄວາມຮັບຜິດຊອບທາງສັງຄົມ',
    myhead_gg: 'ISG Webinar',
    myhead_hh: 'FISG Analysis',
    myhead_ii: 'Trading Course',
    myhead_com: 'ການແຂ່ງຂັນການຊື້ຂາຍຈຳລອງ InterStellar Group ',
  },
  Home: {
    Home_a: ' Star Points Mall ',
    Home_b: 'ເເລກຄະເເນນເປັນຂອງລາງວັນ',
    Home_c:
      'ເເລກຄະເເນນສໍາ​ລັບ​ຂອງ​ຂວັນ​ທີ່​ດີ​, ແຟ​ຊັນ​ດິ​ຈິ​ຕອນ​, ເຄື່ອງ​ໃຊ້​ໄຟ​ຟ້າ​ອະລັງການ, ລົດ​ຫລູ​ຫລາ​ຊັ້ນ​ນໍາ​ແລະ​ຂອງ​ດີ​ຫຼາຍ​ຢ່າງ​ອື່ນໆ​ທີ່ທ່ານສາມາດ​​ເອົາກັບ​ບ້ານ​ໄດ້​ທຸກ​ເວ​ລາ ...',
    Home_d: 'ເບິ່ງເງື່ອນໄຂ ແລະກົດລະບຽບຂອງກິດຈະກຳ',
    Home_e: 'ຄລິກ',
    Home_f: 'ທີ່ນີ້',
    Home_g: 'ຂອງລາງວັນທີ່ດີລໍຖ້າທ່ານຢູ່',
    Home_h: 'ບໍ່ມີຂອງຂວັນທີ່ທ່ານຕ້ອງການ?',
    Home_i:
      'ພວກເຮົາຍິນດີຕ້ອນຮັບທຸກທ່ານທີ່ຈະເເນະນຳຂອງຂວັນທີ່ທ່ານຕ້ອງການກັບພວກເຮົາໄດ້ທຸກເວລາ. ພວກເຮົາຈະເພີ່ມລາຍການເພີ່ມເຕີມໂດຍອີງໃສ່ຄວາມນິຍົມຂອງຂອງຂວັນທີ່ລູກຄ້າແນະນໍາ.',
    Home_j: 'ເເບຣນຂອງລາງວັນ',
    Home_k: 'ລາຍ​ລະ​ອຽດ​ສິນ​ຄ້າ​',
    Home_l: 'ການຍື່ນສະເຫນີ',
    Home_m: 'ກົດການເເລກຂອງລາງວັນຄະເເນນໂບນັດ',
    Home_n: 'ວິທີການຮັບຄະເເນນ',
    Home_o:
      'ລູກຄ້າ FISG ທຸກທ່ານທີ່ຊື້ຂາຍຄູ່ສະກຸນເງິນ, ໂລຫະ ແລະຜະລິດຕະພັນພະລັງງານຢູ່ໃນເເພລດຟອມຂອງພວກເຮົາຈະໄດ້ຮັບເຄຣດິດ 1 ເຄຣດິດສໍາລັບທຸກໆການເທຣດ',
    Home_p: 'ວິທີການເເລກຂອງລາງວັນ',
    Home_q:
      'ສົ່ງຄໍາຮ້ອງສະຫມັກແລກປ່ຽນໃນ points mall (ຕື່ມຂໍ້ມູນຊື່ຂອງທ່ານໃສ່, ຂໍ້ມູນຕິດຕໍ່, ແລະເລກບັນຊີການເທຣດແລະຂໍ້ມູນອື່ນໆ), ຈາກນັ້ນພວກເຮົາຈະທຳການກວດສອບຄະເເນນຂອງທ່ານ ເເລະກວດສອບວ່າທ່ານມີທຸລະກຳທີ່ເຮັດຝ່າຝືນກົດລະບຽບຫຼືບໍ່ ເເລະຈຳທຳການເເລກຄະເເນນກັບຂອງລາງວັນທີ່ທ່ານຕ້ອງການຫຼັງຈາກການກວດສອບສຳເລັດເເລ້ວ',
    Home_r: 'ເວລາຈັດສົ່ງຂອງລາງວັນ',
    Home_s:
      'ຂອງລາງວັນຈະຖືກຈັດສົ່ງພາຍໃນ 15 ມື້ຫຼັງຈາກຄໍາຮ້ອງສະຫມັກການແລກປ່ຽນໄດ້ຮັບການອະນຸມັດ, ກະລຸນາສັງເກດວ່າຈະມີການກວດສອບກ່ອນ, ທ່ານຍັງສາມາດຕິດຕໍ່ກັບຜູ້ຈັດການຝ່າຍບໍລິການລູກຄ້າຂອງທ່ານເອງເພື່ອກວດເບິ່ງຄວາມຄືບຫນ້າການຈັດສົ່ງ.',
    Home_t: 'ຄຳເເນະນຳຫຼັງການຂາຍ',
    Home_u:
      'ສິນຄ້າທັງໝົດທີ່ລະບຸໄວ້ຮ້ານຄ້ານີ້ແມ່ນຖືກຈັດຫາໂດຍຜູ້ສະໜອງພາກສ່ວນທີສາມ third-party suppliers, ແລະບໍ່ມີການຮອງຮັບການສົ່ງຄືນທີ່ບໍ່ສົມເຫດສົມຜົນ. ຢ່າງໃດກໍ່ຕາມ, ຖ້າມີຂອງຂວັນທີ່ບໍ່ຖືກຕ້ອງ, ຫຼືຄວາມເສຍຫາຍໃນຂະບວນການຈັດສົ່ງດ່ວນ, ທ່ານສາມາດຕິດຕໍ່ຝ່າຍບໍລິການລູກຄ້າສະເພາະຂອງທ່ານເພື່ອແກ້ໄຂບັນຫາ.',
    Home_v: 'ຄໍາແນະນໍາຍອດນິຍົມ',
    Home_w: 'ສິນຄ້າທີ່ມີເທຣນຍອດນິຍົມທີ່ສຸດກຳລັງລໍຖ້າທ່ານຢູ່ຕອນນີ້',
    Home_x: 'ແປງ',
    Home_y: 'ຄະເເນນ',
    Home_z: 'ເລືອກແບຣນ',
    Home_aa: 'ຜະລິດຕະພັນໃຫມ່',
    Home_bb: 'ການຈັດຮຽງຄະເເນນ',
    Home_cc: 'ເລືອກແບຣນ',
    Home_dd: 'ສະເພາະ',
    Home_ee: 'ຄະເເນນທີ່ສາມາດເເລກໄດ້',
    Home_ff: 'ກະລຸນາໃສ່ຍີ່ຫໍ້ຂອງລາງວັນ',
    Home_gg: 'ກະລຸນາໃສ່ລາຍລະອຽດຂອງຜະລິດຕະພັນ',
    Home_hh: 'ເງື່ອນໄຂ',
    Home_ii: 'ຄວາມສຳເລັດ',
    Home_zz: 'ສູນລວມຮ້ານຄ້າ',
    Home_kk: 'POINTS MALL',
    Home_search: 'ຄົ້ນຫາ',
    seckill: 'Flash sale',
    daySeckill: 'ເວລາ flash sale ລາຍວັນ',
    cutDownTips: 'ນັບເວລາຖອຍຫລັງກ່ອງສຸ່ມ',
    cutDownTips1: 'ເວລາກ່ອງສຸ່ມສິ້ນສຸດ',
    cutDownTips2: 'ກ່ອງສຸ່ມນອກຊ່ວງເວລາ',
    cutDownTips3: 'ກິດຈະກຳຍັງບໍ່ໄດ້ເລີ່ມ',
  },
  detail: {
    detail_a: 'ກັບໄປໜ້າຫຼັກຮ້ານຄ້າ',
    detail_b: 'ເເບບຕົວຢ່າງ',
    detail_c: 'ໝາຍເລກ',
    detail_d: 'ຄຳເເນະນຳການເເລກຂອງລາງວັນ',
    detail_e:
      'ຂອງລາງວັນຈະຖືກຈັດສົ່ງພາຍໃນ 15 ມື້ຫຼັງຈາກຄໍາຮ້ອງສະຫມັກການແລກປ່ຽນໄດ້ຮັບການອະນຸມັດ, ກະລຸນາສັງເກດວ່າຈະມີການກວດສອບກ່ອນ, ທ່ານຍັງສາມາດຕິດຕໍ່ກັບຜູ້ຈັດການຝ່າຍບໍລິການລູກຄ້າຂອງທ່ານເອງເພື່ອກວດເບິ່ງຄວາມຄືບຫນ້າການຈັດສົ່ງ.',
    detail_f:
      'ສິນຄ້າທັງໝົດທີ່ລະບຸໄວ້ຮ້ານຄ້ານີ້ແມ່ນຖືກຈັດຫາໂດຍຜູ້ສະໜອງພາກສ່ວນທີສາມ third-party suppliers, ແລະບໍ່ມີການຮອງຮັບການສົ່ງຄືນທີ່ບໍ່ສົມເຫດສົມຜົນ. ຢ່າງໃດກໍ່ຕາມ, ຖ້າມີຂອງຂວັນທີ່ບໍ່ຖືກຕ້ອງ, ຫຼືຄວາມເສຍຫາຍໃນຂະບວນການຈັດສົ່ງດ່ວນ, ທ່ານສາມາດຕິດຕໍ່ຝ່າຍບໍລິການລູກຄ້າສະເພາະຂອງທ່ານເພື່ອແກ້ໄຂບັນຫາ.',
    detail_g: 'ລາຍ​ລະ​ອຽດ​ສິນ​ຄ້າ​',
    detail_h: 'ຄໍາແນະນໍາຍອດນິຍົມ',
    detail_i: 'ກະລຸນາເຂົ້າສູ່ລະບົບ',
  },
  settlement: {
    balance: 'ຍອດຄົງເຫຼືອຄະເເນນ',
    settlement_a: 'ຂໍ້ມູນການສັ່ງຊື້',
    settlement_b: 'ຊື່',
    settlement_c: 'ຂໍ້ມູນຈໍາເພາະ',
    settlement_d: 'ລາຄາຫົວໜ່ວຍ',
    settlement_e: 'ໝາຍເລກ',
    settlement_f: 'ຂໍ້ມູນຜູ້ຮັບສົ່ງ',
    settlement_g: 'ເພີ່ມທີ່ຢູ່',
    settlement_h: 'ຈໍານວນການຊໍາລະ',
    settlement_i: 'ຄະເເນນ',
    settlement_z: 'ຊຳລະທັນທີ',
    settlement_k: 'ຢືນຢັນສຳເລັດ',
    settlement_l: 'ກະລຸນາຢືນຢັນການສັ່ງຊື້ຂອງທ່ານ!',
    settlement_m: 'ຜະລິດຕະພັນ',
    settlement_n: 'ຂໍ້ມູນ​ຜະລິດຕະພັນ',
    settlement_o: 'ຂໍ້ມູນຄະເເນນ!',
    settlement_p: 'ຄະເເນນທີ່ຕ້ອງການໃນປະຈຸບັນແມ່ນບໍ່ພຽງພໍ',
    settlement_title: 'ສໍາ​ລັບ​ຄວາມ​ສໍາ​ເລັດ​!',
    settlement_tip:
      'ຄໍາສັ່ງແລກປ່ຽນຂອງທ່ານຈະຖືກຈັດສົ່ງພາຍໃນ 15 ມື້ເຮັດວຽກ. ທ່ານຍັງສາມາດຕິດຕໍ່ກັບຜູ້ຈັດການຝ່າຍບໍລິການລູກຄ້າຂອງທ່ານເອງເພື່ອກວດເບິ່ງຄວາມຄືບຫນ້າຂອງການຈັດສົ່ງ.',
    settlement_button: 'ກຳນົດ',
    settlement_button_err: 'ກຳນົດ',
    settlement_tip_error:
      'ວິທີການໄດ້ຮັບຄະແນນ: ການຊື້ຂາຍຄູ່ສະກຸນເງິນ, ໂລຫະມີຄ່າ, ແລະຜະລິດຕະພັນພະລັງງານ, ທ່ານສາມາດໄດ້ຮັບ 1 ຄະແນນສໍາລັບແຕ່ລະທຸລະກໍາ (ຄໍາສັ່ງທີ່ຖືຫຼາຍກວ່າສາມນາທີແມ່ນຖືວ່າຖືກຕ້ອງ)',
  },
  meber: {
    meber_a: 'ສູນການສັ່ງຊື້',
    meber_b: 'ສູນສ່ວນຕົວ',
    meber_c: 'ຄຳສັ່ງຊື້ຂອງຂ້ອຍ',
    meber_d: 'ການຈັດການທີ່ຢູ່',
    meber_e: 'ອອກຈາກລະບົບ',
  },
  address: {
    address_a: 'ເພີ່ມຂື້ນ',
    address_b: 'ຊື່',
    address_c: 'ເບີໂທ',
    address_d: 'ທີ່ຢູ່',
    address_e: 'ການດຳເນີນການ',
    address_f: 'ການເເກ້ໄຂ',
    address_g: 'ລຶບ',
    address_h: 'ກະລຸນາເລືອກ',
    address_i: 'ທີ່ຢູ່ລະອຽດ',
    address_j: 'ບັນທຶກ',
    address_k: 'ໃສ່ຊື່ຂອງທ່ານ',
    address_l: 'ໃສ່ໝາຍເລກໂທລະສັບຂອງທ່ານ',
    address_m: 'ຮູບແບບເບີໂທລະສັບບໍ່ຖືກຕ້ອງ ',
    address_n: 'ກະລຸນາໃສ່ເບີໂທລະສັບຂອງທ່ານ ',
    address_o: 'ກະລຸນາໃສ່ທີ່ຢູ່ເຕັມ ',
    address_p: 'ແກ້ໄຂສຳເລັດແລ້ວ ',
    address_q: 'ເພີ່ມສຳເລັດແລ້ວ ',
    address_r: 'ລຶບສຳເລັດແລ້ວ',
    address_s: 'ທີ່ຢູ່ການເກັບກ່ຽວໃໝ່',
    address_t: 'ທ່ານຍັງບໍ່ໄດ້ເພີ່ມທີ່ຢູ່ຈັດສົ່ງ ',
  },
  order: {
    order_a: 'ຄໍາສັ່ງຊື້ຂອງຂ້ອຍ',
    order_b: 'ວັນທີ ',
    order_c: 'ໝາຍເລກສັ່ງຊື້ ',
    order_d: 'ຜູ້ຮັບ',
    order_e: 'ຈໍານວນ ',
    order_f: 'ລາຍລະອຽດການສັ່ງຊື້',
    order_g: 'ໂທ',
    order_h: 'ທີ່ຢູ່',
    order_i: 'ລັດ ',
    order_j: 'ຮູບແບບການຂົນສົ່ງ',
    order_k: 'ການດໍາເນີນງານ ',
    order_l: 'ປິດ ',
    order_m: 'ສ້າງແລ້ວ ',
    order_n: 'ຈ່າຍແລ້ວ ',
    order_o: 'ກຳລັງສົ່ງເງິນຄືນ ',
    order_p: 'ສົ່ງເງິນຄືນແລ້ວ ',
    order_q: 'ຈັດສົ່ງແລ້ວ ',
    order_r: 'ສຳເລັດແລ້ວ',
    order_s: 'ມູນຄ່າລວມ',
  },
  userinfo: {
    userinfo_a: 'ສູນສ່ວນຕົວ ',
    userinfo_b: 'ເວລາອັບເດດຫຼ້າສຸດ ',
    userinfo_c: 'ກ່ອງຈົດໝາຍຜູ້ໃຊ້ ',
    userinfo_d: 'ເຄຣດິດທີ່ມີຢູ່ ',
  },
  orderDetail: {
    orderDetail_a: 'ສົ່ງຄໍາສັ່ງ',
    orderDetail_b: 'ການຈ່າຍເງິນສຳເລັດແລ້ວ ',
    orderDetail_c: 'ລາຍການສົ່ງອອກ ',
    orderDetail_d: 'ລໍຖ້າການຈັດສົ່ງ',
    orderDetail_e: 'ສໍາເລັດ ',
    orderDetail_f: 'ວິທີການຈ່າຍເງິນ ',
    orderDetail_g: 'ຊື່ຜູ້ສົ່ງ ',
    orderDetail_h: 'ໝາຍເລກຕິດຕາມ',
  },
  footerbox: {
    footerbox_b: 'ຕະຫຼາດໂລກໃນມື້ນີ້',
    footerbox_c: 'ລອງໃຊ້ບັນຊີຕົວຢ່າງ DEMO',
    footerbox_d: 'ບໍລິການລູກຄ້າອາຊີປາຊີຟິກ (ສິງກະໂປ)',
    footerbox_e: 'ອີເມວຂອງບໍລິສັດ',
    footerbox_f: 'support@interstellarsfx.com',
    footerbox_g: 'ເລີ່ມການຊື້ຂາຍ',
    footerbox_h: 'Forex',
    footerbox_i: 'ໂລຫະມີຄ່າ',
    footerbox_ik: 'ຫຸ້ນ',
    footerbox_j: 'ພະລັງງານ',
    footerbox_k: 'ດັດຊະນີ',
    footerbox_a: 'ກ່ຽວກັບການຊື້ຂາຍ',
    footerbox_l: 'ບັນຊີ',
    footerbox_m: 'ປະເພດຂອງບັນຊີ',
    footerbox_ml: 'ນະ​ໂຍ​ບາຍ Leverage',
    footerbox_n: 'ຝາກ ແລະ ຖອນເງິນ',
    footerbox_o: 'ເລີ່ມການຊື້ຂາຍ',
    footerbox_p: 'ລອງບັນຊີເດໂມ່ຟຣີ',
    footerbox_q: 'ເຄື່ອງມືການຄ້າ',
    footerbox_r: 'MetaTrader 4',
    footerbox_s: 'MAM',
    footerbox_t: 'MultiTerminal',
    footerbox_u: 'ປະຕິທິນເສດຖະກິດ',
    footerbox_v: 'ເຄື່ອງຄິດເລກ Forex',
    footerbox_w: 'VPS',
    footerbox_x: 'ສູນການຊື້ຂາຍ',
    footerbox_y: 'ໂຮງຮຽນການຊື້ຂາຍ',
    footerbox_z: 'ກອງປະຊຸມສະໄໝສາມັນ',
    footerbox_aa: 'ກ່ຽວກັບ InterStellar',
    footerbox_ad: 'ກ່ຽວກັບພວກເຮົາ',
    footerbox_bb: 'ຂ່າວ',
    footerbox_cc: 'ອາຊີບ',
    footerbox_dd: 'ຕິດຕໍ່ພວກເຮົາ',
    footerbox_ee: 'Partnership',
    footerbox_ff: 'FAQ',
    footerbox_mm: 'ຄຳເຕືອນ',
    footerbox_nn:
      "ເວັບໄຊທ໌ www.interstellarsfx.com ແມ່ນດໍາເນີນການໂດຍ First Interstellar Global Ltd, ເຊິ່ງເປັນບໍລິສັດຈໍາກັດທີ່ຈັດຕັ້ງຂື້ນພາຍໃຕ້ກົດຫມາຍຂອງ Seychelles, ໝາຍເລກທະບຽນບໍລິສັດ [ໃສ່ຫມາຍເລກທະບຽນຂອງບໍລິສັດ] ແລະມີຫ້ອງການຈົດທະບຽນຢູ່ທີ່ຫ້ອງເບີ 9, Deenu's Building, Providence, Mahe, Seychelles. First Interstellar Global Ltd ໄດ້ຮັບການອະນຸຍາດເເລະຢູ່ພາຍໃຕ້ການກຳກັບດູເເລຂອງສຳນັກງານບໍລິການທາງການເງິນຂອງ Seychelles. ໝາຍເລກໃບອະນຸຍາດ. SD127. First Interstellar Global Ltd ບໍ່ໄດ້ເປັນສ່ວນໜຶ່ງຂອງລະບຽບການດ້ານການເງິນຂອງເອີຣົບ. The Markets in Financial Instruments Directive (MiFID) II, ເຊັ່ນດຽວກັນກັບກົດລະບຽບການບໍລິການດ້ານການເງິນອື່ນໆຂອງເອີຣົບ, ແມ່ນໃຊ້ບໍ່ໄດ້ກັບການໃຫ້ບໍລິການທາງດ້ານການເງິນໂດຍ First Interstellar Global Ltd. ນອກຈາກນັ້ນ, ຍັງບໍ່ມີການກຳນົດເເຜນການຊົດເຊີຍໃຫ້ກັບນັກລົງທຶນ. ຄຳເຕືອນ: ເວັບໄຊທ໌ www.interstellarsfx.com ແມ່ນດໍາເນີນການໂດຍ First Interstellar Global Ltd, ເຊິ່ງເປັນບໍລິສັດຈໍາກັດທີ່ຈັດຕັ້ງຂື້ນພາຍໃຕ້ກົດຫມາຍຂອງ Seychelles, ໝາຍເລກທະບຽນບໍລິສັດ [ໃສ່ຫມາຍເລກທະບຽນຂອງບໍລິສັດ] ແລະມີຫ້ອງການຈົດທະບຽນຢູ່ທີ່ຫ້ອງເບີ 9, Deenu's Building, Providence, Mahe, Seychelles. First Interstellar Global Ltd ໄດ້ຮັບການອະນຸຍາດເເລະຢູ່ພາຍໃຕ້ການກຳກັບດູເເລຂອງສຳນັກງານບໍລິການທາງການເງິນຂອງ Seychelles. ໝາຍເລກໃບອະນຸຍາດ. SD127. First Interstellar Global Ltd ບໍ່ໄດ້ເປັນສ່ວນໜຶ່ງຂອງລະບຽບການດ້ານການເງິນຂອງເອີຣົບ. The Markets in Financial Instruments Directive (MiFID) II, ເຊັ່ນດຽວກັນກັບກົດລະບຽບການບໍລິການດ້ານການເງິນອື່ນໆຂອງເອີຣົບ, ແມ່ນໃຊ້ບໍ່ໄດ້ກັບການໃຫ້ບໍລິການທາງດ້ານການເງິນໂດຍ First Interstellar Global Ltd. ນອກຈາກນັ້ນ, ຍັງບໍ່ມີການກຳນົດເເຜນການຊົດເຊີຍໃຫ້ກັບນັກລົງທຶນ.",
    footerbox_gg:
      'InterstellarFX ບໍ່ໄດ້ສະເໜີ CFDs ໃຫ້ແກ່ຜູ້ອາໄສຢູ່ໃນບາງເຂດອຳນາດການປົກຄອງ, ລວມທັງສະຫະລັດ, ອີຣ່ານ, ການາດາ, ປະເທດແບນຊິກ ແລະ ຝຣັ່ງ.',
    footerbox_hh: 'ຄຳເຕືອນຄວາມສ່ຽງ:',
    footerbox_ii:
      'ການຊື້ຂາຍເງິນຕາຕ່າງປະເທດແລະຜະລິດຕະພັນທາງດ້ານການເງິນທີ່ໃຊ້ Leverage ມີຄວາມສ່ຽງສູງແລະອາດຈະເຮັດໃຫ້ທ່ານສູນເສຍເງິນທຶນຂອງທ່ານ. ທ່ານບໍ່ຄວນມີຄວາມສ່ຽງການສູນເສຍຫຼາຍກ່ວາຈຳນວນທີ່ທ່ານສາມາດຈ່າຍໄດ້ແລະກະລຸນາກວດສອບໃຫ້ແນ່ໃຈວ່າທ່ານເຂົ້າໃຈຢ່າງເຕັມສ່ວນກ່ຽວກັບຄວາມສ່ຽງທີ່ກ່ຽວຂ້ອງ. ການຊື້ຂາຍຜະລິດຕະພັນທີ່ມີ leverage ບໍ່ເຫມາະສົມສໍາລັບນັກລົງທຶນທັງຫມົດ. ການຊື້ຂາຍຜະລິດຕະພັນທີ່ບໍ່ໄດ້ໃຊ້ leverage ເຊັ່ນ: ຫຸ້ນ ກໍຍັງມີຄວາມສ່ຽງເຊັ່ນກັນຍ້ອນວ່າມູນຄ່າຂອງຫຸ້ນສາມາດຫຼຸດລົງຫຼືເພີ່ມຂື້ນໄດ້ເຊັ່ນດຽວກັນ, ເຊີ່ງຫມາຍຄວາມວ່າທ່ານອາດຈະໄດ້ຮັບເງິນຄືນຫນ້ອຍກວ່າຕອນທີ່ທ່ານລົງທຶນໃນເບື້ອງຕົ້ນ. ຜົນການດຳເນິນງານທີ່ຜ່ານມາໃນອາດີດ ແມ່ນບໍ່ຮັບປະກັນຜົນໄດ້ຮັບໃນອະນາຄົດ. ກ່ອນທີ່ຈະຊື້ຂາຍ, ກະລຸນາພິຈາລະນາລະດັບປະສົບການຂອງທ່ານ, ຈຸດປະສົງການລົງທຶນ ແລະ ຊອກຫາຄໍາແນະນໍາທາງດ້ານການເງິນຈາກນັກລົງທຶນອິດສະຫຼະມືອາຊີບ ຖ້າຈຳເປັນ. ລູກຄ້າມີໜ້າທີ່ຮັບຜິດຊອບໃນການກວດສອບໃຫ້ເເນ່ໃຈວ່າຂໍ້ກໍານົດທາງດ້ານກົດຫມາຍຂອງປະເທດທີ່ຕົນອາໃສຢູ່ ອະນຸຍາດໃຫ້ໃຊ້ບໍລິການຂອງເເບຣນ StarWorld',
    footerbox_zz: 'ຖະແຫຼງການຄວາມສ່ຽງ',
    footerbox_kk: 'ນະໂຍບາຍຄວາມເປັນສ່ວນຕົວ',
    footerbox_ll: 'Copyright © 2021 FISG. All rights reserved.',
  },

  other: {
    topTips1: '1 ຄະແນນ (Point) ເທົ່າກັບ 1 Standard Lot ຫຼື 100 Cent Lots.',
    topTips2: 'ຍັງບໍ່ຮອງຮັບການແລກຂອງຈາກພາກພື້ນອື່ນໆ.',
    topTips3:
      'ຂ້ອຍຢືນຢັນວ່າຄະເເນນໃນລະບົບຕົງກັບຈຳນວນລ໋ອດທີ່ເທຣດຈິງ ເເລະ ໄດ້ເເລກລາງວັນຢ່າງຖືກຕ້ອງ.',
    topTips4:
      'ຂ້ອຍເຂົ້າໃຈວ່າການເເລກຄັ້ງນີ້ຈະເປັນໂມຄະ ຫາກບໍລິສັດກວດສອບເຫັນວ່າຂ້ອຍໃຊ້ຂໍ້ຜິດພາດຂອງລະບົບທີ່ອາດສະເເດງຄະເເນນບໍ່ຕົງຕາມຄວາມເປັນຈິງ.',
  },
}
